import './index.scss'
import React from "react";
const ShareModal = ({ onClose }) => {
  return (
    <div className="fragment-share">
      <img src={require('../../imgs/xiaochengxu.png')} alt=""/>
    </div>
  )
}
export default ShareModal